import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Input, Button, App } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { AppContext } from "../../AppContext";
import { apiLogin } from "../../api/auth";

const Login = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { dispatch, initializeAuth } = useContext(AppContext);

  const onFinish = async (values) => {
    const { email, password } = values;
    setLoading(true);

    try {
      const res = await apiLogin({ email, password, role: 2 });

      // Extract tokens
      const accessToken = res.authToken?.accessToken;
      const refreshToken = res.authToken?.refreshToken;

      // Extract user data WITHOUT authToken
      const { authToken, ...userData } = res;

      // Initialize auth with tokens
      initializeAuth(accessToken, refreshToken);

      // Set user data in context (without authToken)
      dispatch({ type: "SET_CURRENT_USER", data: userData });

      message.success("Đăng nhập thành công");
      navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      message.error(
        err?.message || "Đăng nhập không thành công. Vui lòng kiểm tra lại thông tin đăng nhập của bạn."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Left Image Panel */}
      <div
        className="relative block h-96 lg:h-auto bg-center bg-no-repeat bg-cover"
        style={{
          backgroundImage: "url(/images/signup_bg.png)",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />
        <div className="absolute bottom-8 left-8 right-8">
          <div className="bg-black/40 backdrop-blur-sm text-white rounded-lg p-4">
            <h3 className="text-2xl font-bold">Đăng nhập Cổng thông tin Bác sĩ</h3>
            <p className="text-base opacity-90">
              Truy cập bảng điều khiển của bạn để quản lý các cuộc tư vấn bệnh nhân, theo dõi tiến trình và cung cấp dịch vụ chăm sóc ảo một cách dễ dàng.
            </p>
          </div>
        </div>
        <div className="absolute top-6 left-6">
          <Link to="/">
            <img
              src="/images/logo_white.png"
              alt="MedRev"
              className="h-12 w-auto"
            />
          </Link>
        </div>
        <div className="absolute top-6 right-6 text-white/90 text-base font-medium">
          medrev.com
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center justify-center p-6 bg-white h-full">
        <div className="w-full max-w-md px-6">
          {/* Logo + Heading */}
          <div className="mb-6">
            <Link to="/">
              <img
                src="/images/logo.png"
                alt="MedRev Logo"
                className="h-16 w-auto mb-5"
              />
            </Link>
            <h1 className="text-2xl font-bold text-brand-dark">Chào mừng trở lại!</h1>
            <p className="text-brand-dark/70">
              Đăng nhập để tiếp tục hành trình của bạn.
            </p>
          </div>

          <Form
            layout="vertical"
            onFinish={onFinish}
            requiredMark={false}
            className="space-y-4"
          >
            <Form.Item
              label={
                <span className="text-gray-700 text-sm">Địa chỉ email</span>
              }
              name="email"
              rules={[
                { required: true, message: "Vui lòng nhập email của bạn" },
                { type: "email", message: "Vui lòng nhập địa chỉ email hợp lệ" },
              ]}
            >
              <Input placeholder="you123@gmail.com" className="py-2" />
            </Form.Item>

            <Form.Item
              label={<span className="text-gray-700 text-sm">Mật khẩu</span>}
              name="password"
              rules={[
                { required: true, message: "Vui lòng nhập mật khẩu của bạn" },
              ]}
            >
              <Input.Password
                placeholder="Nhập mật khẩu của bạn"
                className="py-2"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <div className="text-right mb-2">
              <Link
                to="/forgot-password"
                className="text-sm text-purple-600 hover:underline"
              >
                Quên mật khẩu?
              </Link>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="w-full bg-purple-600 hover:bg-purple-700 h-10 font-medium rounded-lg"
              >
                Đăng nhập
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
